/* file description */
import { Button, Tabs, message } from 'antd';
import * as React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';
import styles from './index.module.less';
import { useClick, useConfigFilter, useSaveEvent, useStatusBtns, useMergeBtns } from './effect';
import useValuesStore from '@/store/useValuesStore';
import { RefListType } from '@/asset/AssetTask/templates/Cascade/type';
import { useFreeBtnClick } from '../SPTableList/effect';
import useMetaStore from '@/store/useMetaStore';
// import SpBusinessBtns from '../sp-business-btns';
import SpBusinessBtn from './../sp-business-btns/sp-business-btn';
import { ButtonLayout, ApproverSettingForm, ModalLayout } from '@/asset/AssetTask/templates/Cascade/components';
import RuleController from '../RuleController';
import { useSetState, useDebounceFn } from 'ahooks';


interface SPCascadeBtnPropsType {
  refList: RefListType;
}

export const SPCascadeBtn: React.FC<SPCascadeBtnPropsType> = ({ refList }) => {
  const { utils, pageConfig, taskInfo } = useMetaStore((state) => state);
  const { values, realoadValue } = useValuesStore();

  // 自定义按钮点击
  const { freeButtonClick } = useFreeBtnClick({ refList });
  // 保存事件
  const { save, getSaveRequestBody, getApproverSettingData } = useSaveEvent({ refList });
  // 其他点击事件
  const { editClick, changeStatusClick, copyClick, closeClick, deleteClick } = useClick();

  const { btnList } = useStatusBtns();
  // 按钮根据配置开始过滤
  const { optionList } = useConfigFilter({
    btnList,
  });
  const [btnsLoading, setBtnsLoading] = useSetState<Record<string, boolean>>({});

  // 审批设置
  const [approverData, setApproverData] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const approverSettingFormRef = useRef<any>();
  const [okLoading, setOkLoading] = useState(false);

  // 添加设置按钮状态去抖，保证关闭删除等按钮不出现抖动
  const { run: setBtnsLoadingRun } = useDebounceFn(
    (v) => { setBtnsLoading(v); },
    { wait: 100 },
  );

  const eventsPush = async (type: string, approverSetData?: any) => {
    const Handle = {
      'save-btns': async () => await save('save-btns'),
      'submit-btns': async () => {
        const approverInfo = await getApproverSettingData('submit-btns');
        if (approverInfo.needAssign) {
          setApproverData(approverInfo);
          setIsModalOpen(true);
        } else {
          await save('submit-btns');
        }
      },
      'edit-btns': editClick,
      'copy-btns': copyClick,
      'close-btns': closeClick,
      'delete-btns': deleteClick,
      'approver-setting': async () => await save('submit-btns', approverSetData),
    };
    const handle = Handle[type as keyof typeof Handle];
    // 判定如果事件函数是promise的，则执行loading逻辑
    try {
      if (handle) {
        setBtnsLoadingRun({ [type]: true });
        changeStatusClick();
        await handle();
      }
    } catch (e) {
      console.error(e);
    }
    setBtnsLoadingRun({ [type]: false });
  };

  const bottomFreeBtns = useMemo(() => {
    const extraButtonList = pageConfig?.freeBtnConfig?.filter((config: Record<string, any>) => config?.position === 'pageBottom') ?? [];
    return extraButtonList;
  }, [pageConfig]) || [];
  const haveTaskId = Boolean(utils?.queryParams?.taskId);
  const { renderBtnList } = useMergeBtns({
    bottomFreeBtns,
    optionList,
  });

  const btnRender = renderBtnList.map((btn: any, index: number) => {
    // 配置如果来自任务处理才展示 || 不由任务处理控制则直接展示
    const btnShow = (btn?.isFromTodo && haveTaskId) || !btn?.isFromTodo;
    return btn.isFreeBtn ? (
      <RuleController
        id={btn?.text}
        key={`${btn?.text}`}
        moduleCode={taskInfo?.mainModuleCode}
        ability={btn?.id || btn?.text}
      >
        {
          btnShow && <SpBusinessBtn
            key={btn?.text}
            utils={{ ...utils, reload: realoadValue }}
            btnInfo={btn}
            btnsClick={(value) => freeButtonClick(value, {}, { getSaveRequestBody })}
          />
        }
      </RuleController>
    ) : (
      <RuleController
        id={btn?.type}
        key={`${btn?.type}`}
      >
        <ButtonLayout
          className={styles.onlyBtnStyle}
          key={btn?.type}
          onClick={() => eventsPush(btn?.type)}
          loading={btnsLoading[btn?.type]}
          {...btn?.props}
        >
          {btn?.label}
        </ButtonLayout>
        {
          btn.type === 'submit-btns' && (
            <ModalLayout
              title="审批设置"
              visible={isModalOpen}
              onCancel={() => setIsModalOpen(false)}
              okButtonProps={{
                loading: okLoading,
              }}
              onOk={async () => {
                setOkLoading(true);
                try {
                  await approverSettingFormRef.current?.form?.validateFields();
                } catch (e) {
                  console.error(e);
                  message.error('请填写必选项');
                  setOkLoading(false);
                  return;
                }
                const approverSetData = approverSettingFormRef.current?.form?.getFieldsValue();
                await eventsPush('approver-setting', approverSetData);
                setOkLoading(false);
                setIsModalOpen(false);
              }}
              width={800}
              destroyOnClose
            >
              <ApproverSettingForm
                approverSchema={approverData}
                ref={approverSettingFormRef}
              />
            </ModalLayout>
          )
        }
      </RuleController>
    );
  });

  if (btnRender.length === 0) {
    return null;
  }
  return (
    <div className={`pageBtnBar ${styles.btnBar}`}>
      {btnRender}
    </div>
  );
};
SPCascadeBtn.displayName = 'SPCascadeBtn';
